<template>
  <v-container fluid class="shift-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/shift/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="shifts-table"
              show-select
              single-select
              item-key="_id"
              sort-by="shiftcode"
              :footer-props="footer"
              :headers="header_shift"
              :items="shifts"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteShift"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Shift?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_shift.shiftcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteShift = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteShift(delete_shift)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.shiftstatus="{ item }">
                <v-chip
                  :color="!item.shiftstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.shiftstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editShift(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteShiftDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ShiftList',
  data() {
    return {
      isDeleteShift: false,
      isLoading: false,
      delete_shift: {},
      item_seleted: [],
      header_shift: [
        { text: 'Code', value: 'shiftcode'},
        { text: 'Name', value: 'shiftname'},
        { text: 'Type', value: 'shifttype'},
        { text: 'Create', value: 'createdAt', width: '10%'  },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('Shift', ['shifts', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getShiftsRequest()
  },
  methods: {
    ...mapActions('Shift', ["deleteShiftRequest","getShiftsRequest"]),
    editShift(item) {
      this.$router.push({name: 'ShiftEdit', params: item});
    },
    deleteShift(item) {
      this.deleteShiftRequest({_id: item._id});
      this.isDeleteShift = false;
    },
    deleteShiftDialog(item) {
      this.isDeleteShift = true;
      this.delete_shift = {_id: item._id, shiftcode: item.shiftcode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
